<template>
  <div class="main-layout">
    <div class="page-container">
      <div class="page-content-wrapper">
        <div class="page-content" :class="{ ml55: showThumb }">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
      </div>
      <div class="sm-page-sidebar" v-if="showThumb">
        <ul class="page-sidebar-menu">
          <li
            class="nav-item"
            :data-child="JSON.stringify(videoAIParam)"
            id="0"
            v-if="showVideoAIParam"
          >
            <Tooltip content="视频智能监控" transfer placement="right">
              <Icon custom="iconfont icon-shipinjiankongyemian"/>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            :data-child="JSON.stringify(operateParam)"
            id="1"
            v-if="showOperateParam"
          >
            <Tooltip content="设备总览" transfer placement="right">
              <Icon type="ios-speedometer"/>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            :data-child="JSON.stringify(operateParam)"
            id="2"
            v-if="showOperateParam"
          >
            <Tooltip content="运营中心" transfer placement="right">
              <Icon custom="iconfont icon-homecenter"/>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            data-child
            data-url="/messageManage/messageIndex"
            id="3"
            v-if="showNotifications"
          >
            <Tooltip content="消息中心" transfer placement="right">
              <Icon type="md-notifications"/>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            :data-child="JSON.stringify(equipmentParam)"
            id="4"
            v-if="showEquipmentParam"
          >
            <Tooltip content="设备中心" transfer placement="right">
              <Icon custom="iconfont icon-modular"/>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            :data-child="JSON.stringify(projectParam)"
            id="16"
            v-if="showProjectParam"
          >
            <Tooltip content="项目中心" transfer placement="right">
              <Icon custom="iconfont icon-peizhiguanli"/>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            :data-child="JSON.stringify(afterSaleParam)"
            id="5"
            v-if="showAfterSaleParam"
          >
            <Tooltip content="售后管理" transfer placement="right">
              <Icon custom="iconfont icon--shouhouguanli"/>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            :data-child="JSON.stringify(analysisCenterParam)"
            id="6"
            v-if="showAnalysisCenterParam"
          >
            <Tooltip content="分析中心" transfer placement="right">
              <Icon type="md-stats"/>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            :data-child="JSON.stringify(approvalParam)"
            id="7"
            v-if="showApprovalParam"
          >
            <Tooltip content="审批" transfer placement="right">
              <Icon custom="iconfont icon-approval"/>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>

          <li
            class="nav-item"
            :data-child="JSON.stringify(partFolder)"
            id="8"
            v-if="showPartFolderParam"
          >
            <Tooltip content="物料文档管理" transfer placement="right">
              <Icon type="md-basket"/>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>

          <li
            class="nav-item"
            :data-child="JSON.stringify(knowledgeParam)"
            id="9"
            v-if="showKnowledgeParam"
          >
            <Tooltip content="知识管理" transfer placement="right">
              <i class="fa fa-book"></i>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            data-child
            data-url="/materialManage/materialIndex"
            id="14"
            v-if="showMaterial"
          >
            <Tooltip content="物料管理" transfer placement="right">
              <Icon type="md-notifications"/>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            data-child
            data-url="/districtManage/districtIndex"
            id="15"
            v-if="showDistrict"
          >
            <Tooltip content="区域管理" transfer placement="right">
              <Icon type="md-map"/>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            data-child
            data-url="/customerManage/customerIndex"
            id="10"
            v-if="showCustomerParam"
          >
            <Tooltip content="客户管理" transfer placement="right">
              <i class="fa fa-male"></i>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <!-- <li
            class="nav-item"
            :data-child="JSON.stringify(organizationParam)"
            id="11" v-if="showOrganizationParam"
          >
            <Tooltip content="组织管理" transfer placement="right">
              <Icon custom="iconfont icon-zuzhi" />

            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            data-child=""
            data-url="/user/userIndex"
            id="12" v-if="showSingleUser"
          >
            <Tooltip content="用户管理" transfer placement="right">
              <i class="fa fa-users"></i>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>-->
          <li
            class="nav-item"
            id="13"
            :data-child="JSON.stringify(roleParam)"
            v-if="showRoleParam"
          >
            <Tooltip content="系统管理" transfer placement="right">
              <i class="fa fa-user"></i>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            id="17"
            :data-child="JSON.stringify(feedbackParam)"
            v-if="showFeedbackParam"
          >
            <Tooltip content="问题反馈" transfer placement="right">
              <Icon type="md-headset"/>
            </Tooltip>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
        </ul>
      </div>
      <div class="page-sidebar scroll-cus" v-if="!showThumb">
        <ul class="page-sidebar-menu">
          <li
            class="nav-item"
            :data-child="JSON.stringify(videoAIParam)"
            v-if="showVideoAIParam"
            id="0"
          >
            <Icon custom="iconfont icon-shipinjiankongyemian"/>
            <div class="name fwhite">视频智能监控</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            data-child
            data-url="/operateCenterManage/operateDashboard"
            v-if="showOperateParam"
            id="1"
          >
            <Icon type="ios-speedometer"/>
            <div class="name fwhite">设备总览</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            :data-child="JSON.stringify(operateParam)"
            v-if="showOperateParam"
            id="2"
          >
            <Icon custom="iconfont icon-homecenter"/>
            <!-- <i class="icon-briefcase"></i> -->
            <div class="name fwhite">运营中心</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            id="3"
            data-child
            data-url="/messageManage/messageIndex"
            v-if="showNotifications"
          >
            <Icon type="md-notifications"/>
            <div class="name fwhite">消息中心</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>

          <li
            class="nav-item"
            :data-child="JSON.stringify(equipmentParam)"
            v-if="showEquipmentParam"
            id="4"
          >
            <!-- <i class="iconfontjr icon-jr-equipcenter1"  /> -->
            <Icon custom="iconfont icon-modular" color="#fff"/>
            <!-- <i class="icon-briefcase"></i> -->
            <div class="name fwhite">设备中心</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            :data-child="JSON.stringify(projectParam)"
            v-if="showProjectParam"
            id="16"
          >
            <Icon custom="iconfont icon-peizhiguanli" color="#fff"/>
            <div class="name fwhite">项目中心</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            :data-child="JSON.stringify(afterSaleParam)"
            v-if="showAfterSaleParam"
            id="5"
          >
            <!-- <i class="fa fa-folder-open"></i> -->
            <Icon custom="iconfont icon--shouhouguanli"/>
            <div class="name fwhite">售后管理</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            :data-child="JSON.stringify(analysisCenterParam)"
            v-if="showAnalysisCenterParam"
            id="6"
          >
            <Icon type="md-stats"/>
            <div class="name fwhite">分析中心</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            :data-child="JSON.stringify(approvalParam)"
            v-if="showApprovalParam"
            id="7"
          >
            <!-- <i class="fa fa-paper-plane"></i> -->
            <Icon custom="iconfont icon-approval"/>
            <div class="name fwhite">审批</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>

          <li
            class="nav-item"
            :data-child="JSON.stringify(partFolder)"
            v-if="showPartFolderParam"
            id="8"
          >
            <Icon type="ios-albums"/>
            <div class="name fwhite">物料文档管理</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            :data-child="JSON.stringify(knowledgeParam)"
            v-if="showKnowledgeParam"
            id="9"
          >
            <i class="fa fa-book"></i>
            <div class="name fwhite">知识管理</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            id="14"
            :data-child="JSON.stringify(materialParam)"
            v-if="showMaterial"
          >
            <Icon type="md-basket"/>
            <div class="name fwhite">物料管理</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            id="15"
            data-child
            data-url="/districtManage/districtIndex"
            v-if="showDistrict"
          >
            <Icon type="md-map"/>
            <div class="name fwhite">区域管理</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li
            class="nav-item"
            id="10"
            :data-child="JSON.stringify(customerParam)"
            v-if="showCustomerParam"
          >
            <i class="fa fa-male"></i>
            <div class="name fwhite">客户管理</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <!-- <li class="nav-item" :data-child="JSON.stringify(organizationParam)" id="11" v-if="showOrganizationParam">
            <Icon custom="iconfont icon-zuzhi" />
            <div class="name fwhite">组织管理</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <li class="nav-item" id="12" data-child="" data-url="/user/userIndex" v-if="showSingleUser">
            <i class="fa fa-users"></i>
            <div class="name fwhite">用户管理</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>-->
          <li
            class="nav-item"
            id="13"
            :data-child="JSON.stringify(roleParam)"
            v-if="showRoleParam"
          >
            <i class="fa fa-user fwhite"></i>
            <div class="name fwhite">系统管理</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
          <!-- <li class="nav-item" id="14"  data-child="" data-url="/taskSetManage/taskSettingList" v-if="showCustomerParam">
            <i class="iconfont icon-taskSet"></i>
            <div class="name fwhite">任务设置</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>-->
          <li
            class="nav-item"
            id="17"
            :data-child="JSON.stringify(feedbackParam)"
            v-if="showFeedbackParam"
          >
            <Icon type="md-headset"/>
            <div class="name fwhite">问题反馈</div>
            <span class="selected"></span>
            <span class="arrow"></span>
          </li>
        </ul>
      </div>
      <!-- 二级菜单 -->
      <div
        class="child-sidebar"
        style="overflow-y:auto"
        :class="{ 'l-54': showThumb }"
        v-show="showChild"
      >
        <Menu theme="dark" width="194px" accordion>
          <Submenu
            :key="item.title"
            :name="i"
            v-for="(item, i) in subMenu"
            style="color:white"
          >
            <template slot="title">
              <!-- <Icon v-if="item.custom" :custom="item.custom" class="mr5" /> -->
              <i class="icon-wallet mr5"></i>
              {{ item.title }}
            </template>
            <MenuItem
              :name="i + '-' + o"
              v-for="(elem, o) in item.child"
              :key="elem.id"
              :data-url="elem.url"
              v-on:click.native="routeTo(elem.url)"
            >
              <span style="font-size: 13px">{{ elem.title }}</span>
            </MenuItem>
          </Submenu>
          <template v-for="item in normalMenu">
            <li
              class="sub-nav-item child-menuItem"
              :key="item.title"
              :data-url="item.url"
            >
              <Icon
                v-if="item.custom"
                :custom="item.custom"
                :type="item.icon"
                size="20"
                class="mr5"
              />

              <i v-else class="icon-wallet mr5"></i>
              <span class="title">{{ item.title }}</span>
            </li>
          </template>
        </Menu>
      </div>
      <div class="tags-con" :class="{ l54: showThumb }">
        <route-bar
          ref="tagBar"
          @refreshUrl="refreshCurrentUrl"
          homeUrl="/"
        ></route-bar>
      </div>
      <div class="page-header">
        <div class="page-logo" :class="{ w54: showThumb }">
          <div class="title" v-show="!showThumb">JIARONG</div>
          <div
            class="menu-toggler"
            :class="{ ml5: showThumb }"
            @click="changeShowThumb"
          ></div>
        </div>
      </div>
      <div class="page-foot" :class="{ w54: showThumb }">
        <div>
          <Poptip placement="left" class="userinfo-poptip" width="250">
            <div class="help-menu pointer" v-if="!showThumb">
              <span class="fwhite">
                帮助中心
                <i class="fa fa-question-circle ml5"></i>
              </span>
            </div>
            <div class="help-menu pointer w54" v-if="showThumb">
              <span class="fwhite">
                <i class="fa fa-question-circle ml5"></i>
              </span>
            </div>
            <div class="p0" slot="content">
              <div>
                <div class="userinfo-poptip-item">
                  <a
                    class="f555"
                    :href="this.$prefix + '/pdf/OperationManual-ie.pdf'"
                    download="常见问题下载"
                  >
                    <Icon type="md-book mr5"/>
                    常见问题下载
                  </a>
                </div>
                <div class="userinfo-poptip-item">
                  <a
                    class="f555"
                    :href="this.$prefix + '/pdf/OperationManual-pdf.pdf'"
                    download="操作手册下载"
                  >
                    <Icon type="md-paper mr5"/>
                    操作手册下载
                  </a>
                </div>
              </div>
            </div>
          </Poptip>
        </div>
        <Poptip placement="left" class="userinfo-poptip">
          <div class="pointer w125 text-center pt10 pb10" v-if="!showThumb">
            <div>
              <Icon type="md-person" class="fs25 fwhite"/>
            </div>
            <Tooltip :content="loginPerson" placement="left">
              <div class="mr5 ml5 fwhite no-wrap">{{ loginPerson }}</div>
            </Tooltip>
          </div>
          <div class="pointer w54 text-center pt5 pb5" v-if="showThumb">
            <div class="wp100">
              <Icon type="md-person" class="fs25 fwhite"/>
            </div>
          </div>
          <div class="p0" slot="content">
            <div>
              <div class="userinfo-poptip-item" @click="linkPassword">
                <Icon
                  type="ios-lock-outline"
                  style="font-weight:bold"
                  class="mr8"
                />
                修改密码
              </div>
              <div class="userinfo-poptip-item" @click="logout">
                <i class="icon-key mr8"></i>退出
              </div>
            </div>
          </div>
        </Poptip>
      </div>
      <div class="feedback-btn" id="index-feedback-btn">
        <Button @click="toFeedbackPage">反馈/建议</Button>
        <Button @click="aiShow = true">Ai</Button>
      </div>
      <!-- 悬浮按钮容器 -->
      <div class="fab-container">
        <!-- 子操作按钮（可选） -->
        <transition-group  name="fab-list" tag="div" 
        >
          <el-tooltip
            v-for="item in subButtons" 
            :key="item.id"
            :content="item.title" placement="top-start">
            <Button
              v-show="isFabOpen"
              :key="item.id"
              shape="circle" 
              size="small"
              @click="item.action"
              class="fab-sub-button"
            >
              {{ item.icon }}
            </Button>
          </el-tooltip>
        </transition-group>

        <!-- 主按钮 -->
        <el-tooltip content="快捷操作" placement="left">
          <el-button
            circle
            type="primary"
            class="fab-main"
            @click="toggleFab"
          >
            <i :class="isFabOpen ? 'el-icon-close' : 'el-icon-plus'"></i>
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <Drawer :closable="false" :width="500" v-model="aiShow">
        <iframe
        id="LLMIframe"
        frameborder="0" width="470" height="100%"
        ></iframe>
    </Drawer>
    <div
      class="m-aside-menu-overlay on"
      :class="{ 'l-54': showThumb }"
      v-show="showChild"
      @click="hideChild"
    ></div>
  </div>
</template>

<script>
import pageBread from "./../components/page-bread.vue";
import router from "./../router";
import "driver.js/dist/driver.min.css";
import Driver, {Position} from "driver.js";
import {EventSourcePolyfill} from "event-source-polyfill";

let warnInterval;
export default {
  components: {
    pageBread
  },
  data() {
    return {
      aiShow: false,
      isFabOpen: false,
      subButtons: [
        { id: 1, icon: '👆', action: this.scrollToTop, title: '回到顶部' },
        { id: 2, icon: '🤖', action: this.isShowAfterSaleAgent, title: '售后智能客服' },
      ],
      knowledgeParam: [
        {
          title: "知识列表",
          url: "/knowledgeManage/knowledgeIndex",
          auth: "kbm.checkProject.index",
          custom: "iconfont icon-zhishi",
          type: ""
        }
      ],
      materialParam: [
        {
          title: "仓库设置",
          url: "/materialManage/storeSetting",
          auth: "material.warehouse.page",
          custom: "iconfont icon-data-",
          type: ""
        },
        {
          title: "物料管理",
          url: "/materialManage/materialIndex",
          auth: "kbm.checkProject.index",
          custom: "iconfont icon-zhishi",
          type: ""
        },
        {
          title: "SAP物料",
          url: "/materialManage/sapMaterialIndex",
          auth: "sap.materials.view",
          custom: "iconfont icon-data-",
          type: ""
        },
        {
          title: '物料申请',
          url: '/materialManage/material-request/index',
          auth: 'material.apply.page',
          custom: 'iconfont icon-data-'
        },
        {
          title: '物料申请确认',
          url: '/materialManage/material-confirm/index',
          auth: 'material.apply.itemPageList',
          custom: 'iconfont icon-data-'
        },
        {
          title: '调拨管理(调拨入库)',
          url: '/materialManage/material-transfer/index',
          auth: 'material.transfer.page',
          custom: 'iconfont icon-data-'
        },
        {
          title: '采购申请',
          url: '/materialManage/purchase-request/index',
          auth: 'material.purchase.page',
          custom: 'iconfont icon-data-'
        },
        {
          title: '采购收货(采购入库)',
          url: '/materialManage/purchase-receive/index',
          auth: 'material.purchase.receive.page',
          custom: 'iconfont icon-data-'
        },
        {
          title: '库存转储(转储入库)',
          url: '/materialManage/stock-transfer/index',
          auth: 'material.storage.page',
          custom: 'iconfont icon-data-'
        },
        {
          title: '库存消耗(消耗出库)',
          url: '/materialManage/inventory-consumption',
          auth: 'material.consume.page',
          custom: 'iconfont icon-data-'
        },
        {
          title: '物料退料',
          url: '/materialManage/material-return/index',
          auth: 'material.storageReturn.page',
          custom: 'iconfont icon-data-'
        },
        {
          title: '物料退料确认',
          url: '/materialManage/material-return-confirm/index',
          auth: 'material.storageReturn.itemPageList',
          custom: 'iconfont icon-data-'
        },
        {
          title: '物料退库',
          url: '/materialManage/stock-return/index',
          auth: 'material.consumeReturn.page',
          custom: 'iconfont icon-data-'
        },
      ],
      equipmentParam: [
        {
          title: "设备仪表盘",
          url: "/equipmentCenter/equipmentDashboard",
          auth: "em.equipmentDashboard.list",
          custom: "iconfont icon-jiankong",
          type: ""
        },
        {
          title: "告警列表",
          url: "/warnManage/warnIndex",
          auth: "em.equipmentAlarm.index ",
          custom: "iconfont icon-jingbao",
          type: ""
        },
        {
          title: "设备模版",
          url: "/equipmentCenter/equipmentTemplateIndex",
          auth: "em.config.index",
          custom: "iconfont icon-moban2",
          type: ""
        },
        {
          title: "设备管理",
          url: "/equipmentCenter/equipmentIndex",
          auth: "em.equipment.index",
          custom: "iconfont icon-shebei",
          type: ""
        },
        {
          title: "设备诊断数据",
          url: '/equipmentCenter/patrolAnalysisReports',
          auth: "freqx.patrolRecord.list",
          custom: "iconfont icon-taskSet",
          type: ""
        },
        {
          title: "设备分组",
          url: "/equipmentCenter/equipmentGrouping",
          auth: "em.equipmentGroup.tree",
          custom: "iconfont icon-fenzu",
          type: ""
        },
        {
          title: "网关管理",
          url: "/gatewaySettingManage/gatewayIndex",
          auth: "em.gateway.index",
          custom: "iconfont icon-wangguan",
          type: ""
        },
        {
          title: "任务设置",
          url: "/taskSetManage/taskSettingList",
          auth: "sys.taskSetting.index",
          custom: " iconfont icon-taskSet",
          type: ""
        },
        {
          title: "阻力数据分析",
          url: "/resistanceManage/resistanceIndex",
          // auth: "em.equipmentDashboard.list",
          auth: "em.equipmentRecord.indexResistanceRecord",
          custom: " iconfont icon-taskSet",
          type: ""
        },
        {
          title: "变量分组管理",
          url:
            "/equipmentCenter/equipmentDashboardManage/equipmentVariableGroup",
          auth: "em.equipmentVariableGroup.view",
          custom: "iconfont icon-taskSet",
          type: ""
        }
      ],
      projectParam: [
        {
          title: "项目管理",
          url: "/projectCenter/projectIndex",
          auth: "pj.project.index",
          custom: "iconfont icon-shebei",
          type: ""
        },
        {
          title: "项目地图",
          url: "/projectCenter/map",
          auth: "em.project.index",
          custom: "iconfont icon-ditujiankong",
          type: ""
        },
        {
          title: "项目人员点位分布",
          url: "/projectCenter/groupLocalMap",
          auth: "pj.projectGroupLocal.index",
          custom: "iconfont icon-ditujiankong",
          type: ""
        },
        {
          title: "人员分布打卡记录",
          url: "/user/projectUserLocalRecord",
          auth: "pj.projectUserLocalRecord.list",
          custom: "ivu-icon ivu-icon-ios-list-box",
          type: ""
        }
      ],
      //视频智能监控
      videoAIParam: [
        {
          title: "视频监控",
          url: "/videoSurveillance",
          auth: "vms.homePage.listEquipmentStatusByFactory",
          custom: "iconfont  icon-shipinjiankong",
          type: ""
        },
        {
          title: "AI盒子配置",
          url: "/AIBoxConfig",
          // auth: 'AIBox.index',
          auth: "vms.ai.node.list",
          custom: "iconfont  icon-hezi",
          type: ""
        },

        {
          title: "策略配置",
          url: "/strategyConfig",
          auth: "vms.alarm.page",
          custom: "iconfont  icon-celve",
          type: ""
        },
        {
          title: "告警数据",
          url: "/alarmData",
          auth: "vms.alarm.record.page",
          custom: "iconfont  icon-gaojingrizhi_SMAC",
          type: ""
        },
        {
          title: "告警统计",
          url: "/alarmStat",
          auth: "vms.alarm.record.statisticalPie",
          custom: "iconfont  icon-gaojingtongji1",
          type: ""
        },
        {
          title: "基础配置",
          url: "/factoryConfig",
          auth: "vms.factory.page",
          custom: "iconfont  icon-jichupeizhi",
          type: ""
        }
      ],
      operateParam: [
        // {
        //   title: "运营仪表盘",
        //   url: "/operateCenterManage/operateDashboard",
        //   auth: "em.dashboard.list",
        //   custom:"iconfont icon-yunying",
        //   type: "",
        // },
        {
          title: "地图监控",
          url: "/operateCenterManage/reportDashboard",
          auth: "em.equipment.list",
          custom: "iconfont  icon-ditujiankong",
          type: ""
        },
        {
          title: "集中监控",
          url: "/operateCenterManage/thumbnailMonitor",
          auth: "em.thumbnailGroup.list",
          custom: "iconfont icon-yibiaopan",
          type: ""
        },
        {
          title: "大屏监控",
          url: "/operateCenterManage/screenMonitor",
          auth: "rep.operationReport.fifteenTop",
          custom: "iconfont icon-jiankong",
          type: ""
        },
        {
          title: "可视化监控",
          url: "/operateCenterManage/screenView",
          auth: "rep.repairVisualization.list",
          custom: "iconfont icon-jiankong",
          type: ""
        },
        {
          title: "设备报表",
          url: "/operateCenterManage/analysisReportView",
          auth: [
            {
              auth: "rep.waterAmount.index"
            },
            {
              auth: "rep.electricityAmount.index"
            },
            {
              auth: "rep.sulphateOutbound.index"
            },
            {
              auth: "rep.sulphateStorage.index"
            },
            {
              auth: "rep.material.index"
            },
            {
              auth: "rep.brokenRecord.index"
            },
            {
              auth: "rep.downtimeRecord.index"
            }
          ],
          type: "reportOverview",
          custom: "iconfont icon-tongjiguanli1",
          inPageAuth: true
        },
        {
          title: "大屏数据配置",
          url: "/operateCenterManage/screenMonitorDataSet",
          auth: "rep.operationReport.fifteenTop",

          type: ""
        },
        {
          title: "动态产能日历",
          url: "/autoWaterDateRecord/dynamicCalenderIndex",
          auth: "rep.waterProductRecord.getCalendar",
          custom: "iconfont icon-tongjiguanli",
          type: ""
        },
        // {
        //   title: "预防项目管理",
        //   url: "/preventionProjectManage/preventionProjectGroupIndex",
        //   // todo
        //   auth: "pr.preventionProjectGroup.index",
        //   custom: "iconfont icon-zuzhi",
        //   type: ""

        // },
        {
          title: "预防维护任务管理",
          url: "/preventionProjectManage/preventionIndex",
          // todo 根据权限设置显示
          auth: "pr.taskExecuteRecord.index",
          custom: "iconfont icon-xiangqing",
          type: ""
        },
        {
          title: "萤石云监控管理",
          url: "/operateCenterManage/ezvizEquipmentIndex",
          // todo 根据权限设置显示
          auth: "em.ezvizEquipment.index",
          custom: "iconfont icon-xiangqing",
          type: ""
        }
      ],
      partFolder: [
        {
          title: "物料文档管理",
          url: "/partFolder/partFolderIndex",
          auth: "em.partFolder.tree",
          type: ""
        }
      ],
      approvalParam: [
        {
          title: "审批管理",
          url: "/approval/approvalIndex",
          auth: "collaboration.process.list",
          custom: "iconfont icon-shenpiguanli",
          type: ""
        },
        {
          title: "审批列表",
          url: "/approvalManage/approvalList",
          auth: "collaboration.processInstance.index",
          custom: "iconfont icon-daishenpiliebiao",
          type: ""
        },
        {
          title: "工作流关系",
          url: "/approvalManage/workflowConnection",
          auth: "collaboration.workflowSetting.index",
          custom: "iconfont icon-gongzuoliu",
          type: ""
        }
      ],
      afterSaleParam: [
        {
          title: "报修管理",
          url: "/repairManage/repairIndex",
          custom: "iconfont icon-weixiujilu",
          auth: "pm.repairOrder.index",
          type: ""
        },
        {
          title: "我的工单",
          url: "/myWorkOrderManage/myWorkOrderList",
          auth: "pm.repairOrder.myOrder",
          custom: "iconfont icon-gongdan",
          type: ""
        },
        {
          title: "点检任务管理",
          url: "/checkRecordManage/checkRecordIndex",
          auth: "pm.checkRecord.index",
          custom: "iconfont icon-data-",
          type: ""
        },
        {
          title: "点检项目库",
          url: "/checkProjectStorageManage/checkProjectStorageIndex",
          auth: "pm.checkProjectGroup.index",
          custom: "iconfont icon-xiangmuku",
          type: ""
        },
        {
          title: "巡检任务管理",
          url: "/inspectionRecordManage/inspectionRecordIndex",
          auth: "pm.inspectionRecord.index",
          custom: "iconfont icon-inspection",
          type: ""
        },
        {
          title: "巡检标准库",
          url: "/inspectionProjectManage/inspectionProjectIndex",
          auth: "pm.inspectionProjectGroup.index",
          custom: "iconfont icon-qichukucunluru",
          type: ""
        }
      ],
      analysisCenterParam: [
        {
          title: "报表总览",
          url: "/analysisCenterManage/reportOverview",
          custom: "iconfont icon-tongjiguanli1",
          auth: [
            {
              auth: "rep.waterAmount.index"
            },
            {
              auth: "rep.electricityAmount.index"
            },
            {
              auth: "rep.sulphateOutbound.index"
            },
            {
              auth: "rep.sulphateStorage.index"
            },
            {
              auth: "rep.material.index"
            },
            {
              auth: "rep.brokenRecord.index"
            },
            {
              auth: "rep.downtimeRecord.index"
            }
          ],
          type: "reportOverview",
          inPageAuth: true
        },
        {
          title: "预警设置列表",
          url: "/analysisCenterManage/warnSettingList",
          auth: "rep.warnSetting.index",
          custom: "iconfont icon-tongjiguanli",
          type: ""
        },
        {
          title: "上传/下载中心",
          url: "/analysisCenterManage/uploaderDownLoadCenter",
          auth: "rep.file.index",
          icon: "md-archive",
          type: ""
        },
        {
          title: "发送时间配置",
          url: "/analysisCenterManage/remindSettingIndex",
          auth: "rep.remindSetting.index",
          custom: "iconfont icon-bumen2",
          type: ""
        },
        {
          title: "报表数据锁定",
          url: "/analysisCenterManage/lockDataIndex",
          auth: "rep.lockedSetting.index",
          custom: "iconfont icon-bumen2",
          type: ""
        },
        {
          title: "运营报表",
          fold: true,
          type: "",
          child: [
            {
              title: "配件更换记录管理",
              url: "/equipmentAccessoryReplaceManager/equipAccessoryReplaceRecordList",
              auth: "em.equipmentAccessoryReplaceRecordEntity.page",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            },
            {
              title: "设备水量统计管理",
              url: "/analysisCenterManage/equipWaterStatisticsList",
              auth: "rep.waterAmount.index",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            },
            {
              title: "设备电量统计管理",
              url: "/analysisCenterManage/equipElectricityStatisticList",
              auth: "rep.electricityAmount.index",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            },
            {
              title: "硫酸出库统计管理",
              url: "/analysisCenterManage/sulphateOutStatisticList",
              auth: "rep.sulphateOutbound.index",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            },
            {
              title: "硫酸入库统计管理",
              url: "/analysisCenterManage/sulphateStorageStatisticList",
              auth: "rep.sulphateStorage.index",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            },
            {
              title: "物料统计管理",
              url: "/analysisCenterManage/materialStatisticList",
              auth: "rep.material.index",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            },
            /* 已废弃{
              title: "故障记录统计管理",
              url: "/analysisCenterManage/brokenRecordStatisticList",
              auth: "rep.brokenRecord.index",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            }, */
            {
              title: "停机记录统计管理",
              url: "/analysisCenterManage/downtimeRecordStatisticList",
              auth: "rep.downtimeRecord.index",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            },
            /*已废弃 {
              title: "下拉数据配置",
              url: "/analysisCenterManage/dropDownListSet",
              auth: "rep.dropDownConfig.index",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            }, */
            {
              title: "停机原因管理",
              url: "/analysisCenterManage/downtimeReasonIndex",
              auth: "rep.downtimeReason.index",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            }
          ]
        },
        {
          title: "售后报表",
          fold: true,
          type: "",
          child: [
            {
              title: "报修单统计报表",
              url: "/analysisCenterManage/repairOrderStatistic",
              auth: "rep.repairOrderReport.indexChartData",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            },
            {
              title: "服务报告统计报表",
              url: "/analysisCenterManage/serviceReportStatistic",
              auth: "rep.serviceReport.indexChartData",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            }
          ]
        },
        {
          title: "数据分析",
          fold: true,
          type: "",
          child: [
            {
              title: "实时电导监控",
              url: "/analysisCenterManage/dataAnalysis/conductanceOverview",
              auth: "em.conductanceMonitorConfigure.index",
              custom: "iconfont icon-tongjiguanli1",
              type: ""
            },
            {
              title: "电导监控地图",
              url: "/analysisCenterManage/dataAnalysis/conductanceMap",
              auth: "pj.alarmRecord.index",
              custom: "iconfont icon-tongjiguanli1",
              type: ""
            },
            {
              title: "水质分析",
              url: "/analysisCenterManage/dataAnalysis/waterAnalysis",
              auth: "rep.waterAmount.index",
              custom: "iconfont icon-tongjiguanli1",
              type: ""
            },
            {
              title: "电导报警记录",
              url: "/analysisCenterManage/dataAnalysis/alarmRecord",
              auth: "em.conductanceMonitorConfigure.index",
              custom: "iconfont icon-gaojingrizhi_SMAC",
              type: ""
            },
            {
              title: "水质检测报告",
              url: "/autoWaterDateRecord/rawWaterDataRecordIndex",
              auth: "rep.rawWaterDataRecord.list",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            }
          ]
        },
        {
          title: "报表自动统计",
          fold: true,
          type: "",
          child: [
            {
              title: "设备水量自动统计",
              url: "/autoWaterDateRecord/resultWaterAmountIndex",
              auth: "rep.resultWater.listResultWater",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            },
            {
              title: "设备电量自动统计",
              url: "/autoWaterDateRecord/resultElectricityAmount",
              auth: "rep.electricityResultAmount.index",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            },
            {
              title: "自动抄表变量设置",
              url: "/autoWaterDateRecord/autoWaterDateManageIndex",
              auth: "rep.AutowaterManager.listWaterManager",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            },
            {
              title: "产能数据推送设置",
              url: "/autoWaterDateRecord/waterInfoPushIndex",
              auth: "rep.waterInfoPush.view",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            },
            {
              title: "数据监控推送设置",
              url: "/autoWaterDateRecord/dataListeningInfoPushIndex",
              auth: "rep.dataListeningInfoPush.view",
              custom: "iconfont icon-tongjiguanli",
              type: ""
            }
          ]
        },
        {
          title: "配置管理",
          fold: true,
          type: "",
          child: [
            {
              title: "水量表码管理",
              url: "/analysisCenterManage/configManage/meterCodeManage",
              auth: "rep.waterMeterCode.index",
              custom: "iconfont icon-tongjiguanli1",
              type: ""
            },
            {
              title: "历史数据有效值配置",
              url: "/analysisCenterManage/equipmentRecord/effectiveValueManage",
              auth: "em.effectiveValue.index",
              custom: "iconfont icon-tongjiguanli1",
              type: ""
            },
            {
              title: "电导监控配置",
              url: "/analysisCenterManage/dataAnalysis/conductanceSetting",
              auth: "em.conductanceMonitorConfigure.index",
              custom: "iconfont icon-tongjiguanli1",
              type: ""
            }
          ]
        }
      ],
      organizationParam: [
        {
          title: "部门列表",
          url: "/organizationManage/departmentIndex",
          auth: "auth.department.tree",
          custom: "iconfont icon-bumen2",
          type: ""
        }
      ],
      customerParam: [
        {
          title: "客户列表",
          url: "/customerManage/customerIndex",
          auth: "auth.customer.index",
          custom: "iconfont icon-zuzhi",
          type: ""
        },
        {
          title: "客户满意度",
          url: "/customerManage/customerSatisfaction",
          auth: "auth.satisfaction.index",
          custom: "iconfont icon-zuzhi",
          type: ""
        },
        {
          title: "客户满意度的统计分析",
          url: "/customerManage/customerSatisfactionView",
          auth: "auth.satisfaction.view",
          custom: "iconfont icon-zuzhi",
          type: ""
        }
      ],
      roleParam: [
        {
          title: "组织管理",
          url: "/organizationManage/departmentIndex",
          auth: "auth.department.tree",
          custom: "iconfont icon-zuzhi",
          type: ""
        },
        {
          title: "用户管理",
          url: "/user/userIndex",
          auth: "auth.user.index",
          custom: "fa fa-users",
          type: ""
        },
        {
          title: "角色管理",
          url: "/role/roleIndex",
          auth: "auth.role.index",
          custom: "iconfont icon-jiaoseguanli",
          type: ""
        },
        {
          title: "数据权限",
          url: "/data/authorityIndex",
          auth: "sys.userEquipmentGroupAction.index",
          custom: "iconfont icon-jiaoseguanli",
          type: ""
        },
        {
          title: "登录日志",
          url: "/sys/loginLogIndex",
          auth: "sys.loginLog.index",
          custom: "iconfont icon-jiaoseguanli",
          type: ""
        },
        {
          title: "第三方平台",
          url: "/sys/thirdSysIndex",
          auth: "sys.loginLog.index",
          custom: "iconfont icon-wangguan",
          type: ""
        }
      ],
      feedbackParam: [
        {
          title: "反馈记录",
          url: "/sys/feedbackIndex",
          auth: "sys.feedback.index",
          custom: "iconfont icon-gongdan",
          type: ""
        }
      ],
      subMenu: [],
      param: [],
      currentUrl: "",
      currentUrlName: "",
      normalMenu: [],
      authList: [],
      loginPerson: "",
      username: "",
      userId: "",
      showChild: false,
      showThumb: false,
      driver: null,
      eventSource: null
    };
  },
  mounted() {
    window.addEventListener('scroll', () => {
      if (this.isFabOpen) {
        this.isFabOpen = false;
      }
    });
    this.authList = JSON.parse(sessionStorage.getItem("authList"));
    let userInfo = JSON.parse(sessionStorage.getItem("user"));
    this.username = userInfo.username;
    this.userId = userInfo.id;
    this.loginPerson = userInfo.name + "(" + userInfo.username + ")";
    this.currentUrl = "/#" + router.history.current.fullPath;
    this.currentUrlName = router.history.current.meta.title;
    $(document).off("click", ".nav-item");
    $(document).on("click", ".nav-item", e => {
      this.childMenu(
        e.currentTarget.getAttribute("id"),
        e.currentTarget.getAttribute("data-child")
      );
    });

    $(document).off("click", ".child-menuItem");
    $(document).on("click", ".child-menuItem", e => {
      this.routeTo(e.currentTarget.getAttribute("data-url"), "url");
    });

    //获取告警
    /*暂时取消设备告警弹窗
    if (this.currentUrl.indexOf("mobile") < 0) {
      this.circleWarn();
    } else {
      window.clearInterval(warnInterval);
    }
    */
    if (!localStorage.getItem("driver-tag")) {
      this.guide();
    }
    //设备报警消息
    this.createSSE();
  },
  computed: {
    showVideoAIParam() {
      if (this.parentAuth(this.videoAIParam) || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showStrategyParam() {
      if (this.parentAuth(this.strategyParam) || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },

    showKnowledgeParam() {
      if (this.parentAuth(this.knowledgeParam) || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showEquipmentParam() {
      if (this.parentAuth(this.equipmentParam) || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showProjectParam() {
      if (this.parentAuth(this.projectParam) || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showOperateParam() {
      if (this.parentAuth(this.operateParam) || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showPartFolderParam() {
      if (this.parentAuth(this.partFolder) || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showSingleUser() {
      if (this.inAuth("auth.user.index") || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showOrganizationParam() {
      if (
        this.parentAuth(this.organizationParam) ||
        this.username == "makeit"
      ) {
        return true;
      } else {
        return false;
      }
    },
    showRoleParam() {
      if (this.parentAuth(this.roleParam) || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showFeedbackParam() {
      if (this.parentAuth(this.feedbackParam) || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showAfterSaleParam() {
      if (this.parentAuth(this.afterSaleParam) || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showAnalysisCenterParam() {
      if (
        this.parentAuth(this.analysisCenterParam) ||
        this.username == "makeit"
      ) {
        return true;
      } else {
        return false;
      }
    },
    showApprovalParam() {
      if (this.parentAuth(this.approvalParam) || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showCustomerParam() {
      if (this.inAuth("cust.customer.index") || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showNotifications() {
      if (this.inAuth("cust.customer.index") || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showMaterial() {
      if (this.inAuth("pm.part.index") || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    },
    showDistrict() {
      if (this.inAuth("cust.customer.index") || this.username == "makeit") {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    param: {
      handler(newVal, oldVal) {
        let subMenu = [];
        let normalMenu = [];
        this.param.map((item, index) => {
          if (
            item.fold &&
            (this.parentAuth(item.child) || this.username == "makeit")
          ) {
            let project = {...item};
            project.child = [];
            item.child.map(elem => {
              if (
                (elem.inPageAuth
                  ? this.parentAuth(elem.auth)
                  : this.inAuth(elem.auth)) ||
                this.username == "makeit"
              ) {
                project.child.push(elem);
              }
            });
            subMenu.push(project);
          } else if (
            !item.fold &&
            ((item.inPageAuth
                ? this.parentAuth(item.auth)
                : this.inAuth(item.auth)) ||
              this.username == "makeit")
          ) {
            normalMenu.push(item);
          }
          if (index == this.param.length - 1) {
            this.subMenu = subMenu;
            this.normalMenu = normalMenu;
          }
        });
      },
      deep: true
    }
  },
  methods: {
    toggleFab() {
      this.isFabOpen = !this.isFabOpen;
    },
    scrollToTop() {
      //todo:置顶不成功,排查
      const container = document.documentElement || document.body;
      container.scrollTop = 0;
    },
    isShowAfterSaleAgent(){
      this.aiShow = !this.aiShow;
      const iframeLLM = document.getElementById("LLMIframe");
      if (!iframeLLM.src) {
        iframeLLM.src = "/chat/llm/"; // 替换为你想加载的 URL
    }
    },
    parentAuth(param) {
      if (param.length == 0) {
        return false;
      }
      for (let i = 0, len = param.length; i < len; i++) {
        if (param[i].fold == true) {
          for (let j = 0, childLen = param[i].child.length; j < childLen; j++) {
            if (
              param[i].child[j].inPageAuth
                ? this.parentAuth(param[i].child[j].auth)
                : this.inAuth(param[i].child[j].auth)
            ) {
              return true;
            }
          }
        } else if (
          param[i].inPageAuth
            ? this.parentAuth(param[i].auth)
            : this.inAuth(param[i].auth)
        ) {
          return true;
        }
        if (i == param.length - 1) {
          return false;
        }
      }
    },
    //权限判断
    inAuth(param) {
      return this.authList.includes(param);
    },
    childMenu(e, param) {
      $(".nav-item").removeClass("active");
      $("#" + e).addClass("active");
      $(".nav-item")
        .find(".selected")
        .removeClass("open");
      $(".nav-item")
        .find(".arrow")
        .removeClass("open");
      if (param != "") {
        this.param = JSON.parse(param);
        this.showChild = true;
        $("#" + e)
          .find(".arrow")
          .addClass("open");
      } else {
        this.showChild = false;
        $("#" + e)
          .find(".selected")
          .addClass("open");
        this.$router.push($("#" + e).data("url"));
        setTimeout(() => {
          this.currentUrl = "/#" + router.history.current.fullPath;
          this.currentUrlName = router.history.current.meta.title;
        }, 500);
      }
    },
    refreshCurrentUrl(data) {
      let url = data;
      if (url.indexOf("/operateCenterManage/operateDashboard") > -1) {
        $(".nav-item").removeClass("active");
        $("#1").addClass("active");
      } else if (
        url.indexOf("/operateCenterManage/reportDashboard") > -1 ||
        url.indexOf("/operateCenterManage/thumbnailMonitor") > -1
      ) {
        $(".nav-item").removeClass("active");
        $("#2").addClass("active");
      } else if (url.indexOf("messageManage") > -1) {
        $(".nav-item").removeClass("active");
        $("#3").addClass("active");
      } else if (
        url.indexOf("equipmentCenter") > -1 ||
        url.indexOf("warnManage") > -1 ||
        url.indexOf("gatewaySettingManage") > -1 ||
        url.indexOf("taskSetManage") > -1
      ) {
        $(".nav-item").removeClass("active");
        $("#4").addClass("active");
      } else if (
        url.indexOf("repairManage") > -1 ||
        url.indexOf("myWorkOrderManage") > -1 ||
        url.indexOf("checkRecordManage") > -1 ||
        url.indexOf("checkProjectStorageManage") > -1 ||
        url.indexOf("inspectionRecordManage") > -1 ||
        url.indexOf("inspectionProjectManage") > -1
      ) {
        $(".nav-item").removeClass("active");
        $("#5").addClass("active");
      } else if (url.indexOf("analysisCenterManage") > -1) {
        $(".nav-item").removeClass("active");
        $("#6").addClass("active");
      } else if (
        url.indexOf("approval") > -1 ||
        url.indexOf("approvalManage") > -1
      ) {
        $(".nav-item").removeClass("active");
        $("#7").addClass("active");
      } else if (url.indexOf("partFolder") > -1) {
        $(".nav-item").removeClass("active");
        $("#8").addClass("active");
      } else if (url.indexOf("knowledgeManage") > -1) {
        $(".nav-item").removeClass("active");
        $("#9").addClass("active");
      } else if (url.indexOf("customerManage") > -1) {
        $(".nav-item").removeClass("active");
        $("#10").addClass("active");
      } else if (url.indexOf("organizationManage") > -1) {
        $(".nav-item").removeClass("active");
        $("#11").addClass("active");
      } else if (url.indexOf("/user/userIndex") > -1) {
        $(".nav-item").removeClass("active");
        $("#12").addClass("active");
      } else if (url.indexOf("/role/roleIndex") > -1) {
        $(".nav-item").removeClass("active");
        $("#13").addClass("active");
      } else if (url.indexOf("projectCenter") > -1) {
        $(".nav-item").removeClass("active");
        $("#16").addClass("active");
      } else if (url.indexOf("/sys/feedbackIndex") > -1) {
        $(".nav-item").removeClass("active");
        $("#17").addClass("active");
      } else if (url == "/") {
        $(".nav-item").removeClass("active");
        return "";
      }
    },
    changeShowThumb() {
      this.showThumb = !this.showThumb;
    },
    routeTo(param) {
      if (param === router.history.current.path) {
        this.hideChild();
        return "";
      }
      this.showChild = false;
      this.$router.push(param);
      $(".nav-item.active")
        .find(".arrow")
        .removeClass("open");
      $(".nav-item.active")
        .find(".selected")
        .addClass("open");

      setTimeout(() => {
        this.currentUrl = "/#" + router.history.current.fullPath;
        this.currentUrlName = router.history.current.meta.title;
        this.hideChild();
      }, 500);
    },
    hideChild() {
      this.showChild = false;
      setTimeout(() => {
        let url = this.$router.history.current.fullPath;
        //消息
        if (url.indexOf("/operateCenterManage/operateDashboard") > -1) {
          $(".nav-item").removeClass("active");
          $("#1").addClass("active");
        } else if (
          url.indexOf("/operateCenterManage/reportDashboard") > -1 ||
          url.indexOf("/operateCenterManage/thumbnailMonitor") > -1
        ) {
          $(".nav-item").removeClass("active");
          $("#2").addClass("active");
        } else if (url.indexOf("messageManage") > -1) {
          $(".nav-item").removeClass("active");
          $("#3").addClass("active");
        } else if (
          url.indexOf("equipmentCenter") > -1 ||
          url.indexOf("warnManage") > -1 ||
          url.indexOf("gatewaySettingManage") > -1 ||
          url.indexOf("taskSetManage") > -1
        ) {
          $(".nav-item").removeClass("active");
          $("#4").addClass("active");
        } else if (
          url.indexOf("repairManage") > -1 ||
          url.indexOf("myWorkOrderManage") > -1 ||
          url.indexOf("checkRecordManage") > -1 ||
          url.indexOf("checkProjectStorageManage") > -1 ||
          url.indexOf("inspectionRecordManage") > -1 ||
          url.indexOf("inspectionProjectManage") > -1
        ) {
          $(".nav-item").removeClass("active");
          $("#5").addClass("active");
        } else if (url.indexOf("analysisCenterManage") > -1) {
          $(".nav-item").removeClass("active");
          $("#6").addClass("active");
        } else if (
          url.indexOf("approval") > -1 ||
          url.indexOf("approvalManage") > -1
        ) {
          $(".nav-item").removeClass("active");
          $("#7").addClass("active");
        } else if (url.indexOf("partFolder") > -1) {
          $(".nav-item").removeClass("active");
          $("#8").addClass("active");
        } else if (url.indexOf("knowledgeManage") > -1) {
          $(".nav-item").removeClass("active");
          $("#9").addClass("active");
        } else if (url.indexOf("customerManage") > -1) {
          $(".nav-item").removeClass("active");
          $("#10").addClass("active");
        } else if (url.indexOf("organizationManage") > -1) {
          $(".nav-item").removeClass("active");
          $("#11").addClass("active");
        } else if (url.indexOf("/user/userIndex") > -1) {
          $(".nav-item").removeClass("active");
          $("#12").addClass("active");
        } else if (url.indexOf("/role/roleIndex") > -1) {
          $(".nav-item").removeClass("active");
          $("#13").addClass("active");
        }
        $(".nav-item.active")
          .find(".arrow")
          .removeClass("open");
        $(".nav-item.active")
          .find(".selected")
          .addClass("open");
      }, 100);
    },
    linkPassword() {
      this.$router.push("/user/changePassword");
    },
    logout() {
      sessionStorage.clear();
      window.clearInterval(warnInterval);
      this.$router.push({name: "login"});
    },

    // child-sidebar
    circleWarn() {
      this.getWarnIndex();
      warnInterval = setInterval(() => {
        this.getWarnIndex();
      }, 30000);
    },
    getWarnIndex() {
      let alarmSort = sessionStorage.getItem("alarmSort");
      this.$request.get(
        this.$prefix + "/em/equipmentAlarmRecord/getAlarmRecord",
        {
          sort: alarmSort
        },
        res => {
          alarmSort = Number(alarmSort) + Number(1);
          sessionStorage.setItem("alarmSort", alarmSort);
          let content =
            res.createdAt +
            ",设备 " +
            (res.equipment ? res.equipment.name : "") +
            "触发了" +
            res.content;
          this.$Notice.warning({
            title: "设备触发报警",
            render: h => {
              if (res.path != null) {
                return h("div", [
                  h("div", {style: {lineHeight: "16px"}}, content),
                  h("iframe", {
                    class: "playnone",
                    attrs: {
                      src: this.$prefix + "/" + res.path,
                      allow: "autoplay"
                    }
                  })
                ]);
              } else {
                return h("span", [
                  h(
                    "p",
                    "设备名称：" + (res.equipment ? res.equipment.name : "")
                  ),
                  h("p", "触发时间：" + res.createdAt),
                  "报警内容：" + res.content
                ]);
              }
            },
            duration: 5,
            top: 0
          });
        },
        res => {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error",
            duraton: 5
          });
        },
        () => {
          this.$message({
            showClose: true,
            message: "获取告警提示失败",
            type: "error",
            duraton: 5
          });
        }
      );
    },
    guide() {
      const driver = new Driver({
        animate: true,
        doneBtnText: "完成",
        closeBtnText: "关闭",
        //opacity: 0.5,
        padding: 10,
        stageBackground: "#ffffff00",
        onHighlighted: () => this.setLocalStorage()
      });
      driver.highlight({
        element: "#index-feedback-btn",
        popover: {
          title: "提交反馈",
          description:
            "在平台使用中或项目上设备遇到的问题可以在这里反馈，会有专人为你处理哦^_^",
          position: "top-right"
        }
      });
    },
    setLocalStorage() {
      if (localStorage.getItem("driver-tag-num") === '2') {
        localStorage.setItem("driver-tag", 'true');
      } else {
        let num = localStorage.getItem("driver-tag-num")
          ? localStorage.getItem("driver-tag-num")
          : 0;
        localStorage.setItem("driver-tag-num", parseInt(num) + 1);
      }
    },
    toFeedbackPage() {
      this.$router.push({
        name: "feedbackUpload"
      });
    },

    createSSE() {
      let that = this;
      let userId = this.userId;
      if (window.EventSource) {
        // 建立连接
        let url = this.$prefix + "/sse/connect/" + userId;

        this.eventSource = new EventSourcePolyfill(url, {
          headers: {
            token: window.sessionStorage.getItem("token")
          },
          heartbeatTimeout: 10 * 60 * 1000
        });
        /**
         * 连接一旦建立，就会触发open事件
         */
        this.eventSource.addEventListener(
          "open",
          function (e) {
            console.log("sse建立连接。。。");
          },
          false
        );

        /**
         * 客户端收到服务器发来的数据
         */
        this.eventSource.addEventListener("message", function (e) {
          let isShow = localStorage.getItem("showNotificationFlag");
          if (isShow === "1") {
            let data = JSON.parse(e.data);
            if (data.projectId > 0) {
              that.$Notice.warning({
                title: "进水电导超过阈值告警",
                desc: "进水电导超过阈值告警 ",
                render: h => {
                  return h("span", [
                    h(
                      "p",
                      "项目名称：" +
                      (data.project.name ? data.project.name : "")
                    ),
                    h("p", "触发时间：" + data.triggerTime),
                    "报警内容：" + data.content
                  ]);
                },
                duration: 3
              });
            } else {
              that.$Notice.warning({
                title: "设备告警",
                desc: "设备告警 ",
                render: h => {
                  return h("span", [
                    h(
                      "p",
                      "设备名称：" + (data.equipment ? data.equipment : "")
                    ),
                    h("p", "触发时间：" + data.time),
                    "报警内容：" + data.content
                  ]);
                },
                duration: 3
              });
            }
          }
        });
      } else {
        console.log("你的浏览器不支持SSE");
      }
    },

    closeSSE() {
      if (this.eventSource) {
        let userId = this.userId;
        let url = this.$prefix + "/sse/close/" + userId;
        // 关闭SSE
        this.eventSource.close();
        console.log("退出登录或关闭浏览器，关闭SSE连接~");
        this.eventSource = null;
        // 通知后端关闭连接
        this.$request.get(url, {}, res => {
        });
      }
    }
  },

  beforeDestroy() {
    this.closeSSE();
  }
};
</script>
<style>
  .fab-container {
    position: fixed;
    bottom: 100px;
    right: 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    z-index: 2000;
  }
  
  .fab-sub-button {
    width: 40px;
    height: 40px;
    margin-bottom: 20px;
    border: none;
    font-weight: bold;
  }
  
  .fab-sub-button:hover {
    background: #f4f4f5;
  }
  
  .fab-main {
    width: 56px;
    height: 56px;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
    z-index: 2001;
  }
  
  /* 动画 向下慢收*/
.fab-list-enter-active,
.fab-list-leave-active {
  transition: all 0.3s ease;
}
.fab-list-enter-from,
.fab-list-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

</style>


// WEBPACK FOOTER //
// src/views/index.vue